import * as React from 'react';

import * as style from './PageWrapper.css';

interface IPageWrapperProps {
  children: React.ReactNode;
}

export const PageWrapper: React.FC<IPageWrapperProps> = ({ children }) => {
  return <div className={style['container']}>{children}</div>;
};
